import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { ArrowDown } from '../../SVG/ArrowDown';
import { useActiveLocales, useSetUserLanguage } from '../../hooks/useLanguages';
import './index.scss';

const LanguageSelector = () => {
  const { changeLanguage, language } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { data: localesData, refetch } = useActiveLocales();
  const { mutate: setUserLanguage } = useSetUserLanguage();
  const languages = localesData ? [...localesData?.map(locale => ({
    code: locale.code,
    name: locale.name,
    flag: locale.url
  }))] : [{code: 'en', name: 'English', flag: 'https://inspections-api.ndx-dev.com/flags/en.png'}];

  const currentLanguage = languages?.find(lang => lang.code === language) || languages[0];

  const handleLanguageChange = async (langCode) => {
    if (langCode !== language) {
      try {
        await changeLanguage(langCode);
        const localeId = localesData?.find(locale => locale.code === langCode)?.id;
        if(localeId) {
          setUserLanguage(localeId);
        }
        setIsOpen(false);
      } catch (error) {
        console.error('Failed to change language:', error);
      }
    }
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="language-selector" ref={dropdownRef}>
      <button
        className="language-selector__trigger"
        onClick={toggleDropdown}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <span className="flag">
          <img style={{width: '16px', height: '16px'}} src={currentLanguage?.flag} alt={currentLanguage?.name} />
        </span>
        <span className="name">{currentLanguage?.name}</span>
        <span className={`arrow ${isOpen ? 'up' : 'down'}`}>
          {
            languages.length > 1 && (
              <ArrowDown/>
            )
          }
        </span>
      </button>
      
      {isOpen && (
        <div className="language-selector__dropdown">
          {languages.map((lang) => (
            <button
              key={lang.code}
              className={`language-selector__option ${language === lang.code ? 'active' : ''}`}
              onClick={() => handleLanguageChange(lang.code)}
            >
              <span className="flag">
                <img style={{width: '16px', height: '16px'}} src={lang.flag} alt={lang.name} />
              </span>
              <span className="name">{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
